import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiSolidCheckCircle, BiSolidXCircle } from "react-icons/bi";
import UploadReport from "./uploadReport";
import TestForPackage from "./testsByPackagePopup";
import { FiInfo } from "react-icons/fi";
import { Pagination } from "react-bootstrap";
import DisclaimerPopup from "./disclaimerPopup";
import AppointmentReschedule from "./appointmentReschedule";
import { FaDownload, FaEdit, FaEye, FaRedoAlt } from 'react-icons/fa';
import FamilyAppointmentCancel from "./familyAppointmentCancelPopup";
import jsPDF from "jspdf";
import tmplLogo from "../images/tmplLogo.png";
import DoctorDisclaimerPopup from "./doctorDisclaimerPopup";
import RescheduleDoctorAppointment from "./rescheduleDoctorAppointment";
import CancelDoctorAppointment from "./cancelDoctorAppointment";
import UploadDoctorApppointmentReport from "./uploadDoctorAppointmentReport";
import "./hm-theme.css";

function EmployeeDoctorAppointment() {
  const { userid: paramUserId } = useParams();
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [employee, setEmployee] = useState(null);

  const navigate = useNavigate();
  const tokenData = JSON.parse(localStorage.getItem("data"));
  const token = tokenData?.token;
  const userRole = tokenData?.role;
  const loggedInUserId = tokenData?.userid; // Assuming "userid" is stored in localStorage

  // Determine which userid to use
  const userid = userRole === 'ROLE_EMPLOYEE' ? loggedInUserId : paramUserId;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  const searchData = async () => {
    setLoader(true);
    try {
      const searchUrl = `/api/doctor-appointment/employeeId=${employee.id}`;
      const response = await axios.get(searchUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(response.data);
      // setFilteredData(response.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {

    try {
      setLoader(true);
      const empRes = await axios.get(`/api/employeedetails/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmployee(empRes.data);

      const trans = await axios.get(`/api/doctorappointment/getAllAppointmentsByEmployeeId/employeeId=${empRes.data?.id}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);

    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
      else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleViewReport = (reportId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const url = `/api/doctor-appointment-reports/view/${reportId}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      window.open(blobUrl, "_blank");
    }).catch(() => toast.error("Failed to view report."));
  };

  const handleDownloadReport = (reportId, fileName) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    axios({
      url: `/api/doctor-appointment-reports/view/${reportId}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName || "report");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }).catch(() => toast.error("Failed to download report."));
  };

  const handleBack = () => {
    navigate(-1);
  };

  const [loading, setLoading] = useState(null);
  function rsubmit(e, id, status) {
    e.preventDefault();
    setLoading(id);

    const token = JSON.parse(localStorage.getItem("data")).token;

    const entitiesToUpdate = ({
      id: id,
      reportstatus: status,
    });

    axios
      .post(
        "/api/doctorappointment/approve",
        entitiesToUpdate,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        console.log(response.data);
        setLoading(null);
        getData();
      })
      .catch((error) => {
        handleError(error);
      });
  }


  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);

  const handleUploadReport = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsUploadModalOpen(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    setSelectedAppointmentId(null);
    getData();
  };

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [tests, setTests] = useState([]);


  const handleFetchReport = async (appointment) => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/employeeappointment/fetchReport', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Report fetched successfully');
      getData();
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  const [showImageModal, setShowImageModal] = useState(false);

  const handleBookApp = () => setShowImageModal(true);
  const handleCloseModal = () => setShowImageModal(false);

  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);

  const handleCancelAppointment = async (appointment) => {
    setSelectedAppointmentId(appointment)
    setIsCancelPopupOpen(true);
  };

  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    setSelectedAppointmentId(null);
    getData();
  };

  const handleAcceptAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      await axios.post(
        "/api/doctorappointment/accept-or-reschedule",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CONFIRMED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Doctor Appointment Confirmed successfully.");
      getData();
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);

    }
  };

  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    setSelectedAppointmentId(null);
    getData();
  };


  return (
    <div>
      {/* Section Header */}
      <div className="hm-card-header mb-3" style={{ background: "transparent", border: "none", padding: "0 0 0.5rem 0" }}>
        <h4 className="hm-card-title">
          <i className="material-icons">medical_services</i>
          Doctor Appointments
        </h4>
        <button className="btn-hm-primary" onClick={handleBookApp} type="button">
          <i className="material-icons" style={{ fontSize: "1rem" }}>add</i>
          Book Doctor Appointment
        </button>
      </div>

      {/* Table Card */}
      <div className="hm-card">
        <div className="hm-card-body p-0">
          <div style={{ overflowX: "auto" }}>
            <table className="hm-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Employee</th>
                  <th>Txn Date</th>
                  <th>Appt Date</th>
                  <th>Doctor</th>
                  <th>Contact</th>
                  <th>Status</th>
                  <th>Reports</th>
                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="8">
                      <div className="hm-empty-state">
                        <i className="material-icons">medical_services</i>
                        <p>No doctor appointments found</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td>{index + 1}</td>
                      <td>
                        <span className="fw-semibold">
                          {appointment.emplo?.name} {appointment.emplo?.lastname}
                        </span>
                      </td>
                      <td>{appointment.transactionDate}</td>
                      <td>{appointment.appointmentDate}</td>
                      <td>
                        <div className="fw-semibold">{appointment.doctor?.doctorName}</div>
                        <div className="text-muted" style={{ fontSize: "0.75rem" }}>{appointment.doctor?.email}</div>
                      </td>
                      <td>{appointment.doctor?.phoneNumber}</td>
                      <td>
                        <span className={
                          appointment.appStatus?.appointmentStatus?.includes("CANCELLED") ? "hm-badge hm-badge-danger" :
                          appointment.appStatus?.appointmentStatus?.includes("COMPLETED") ? "hm-badge hm-badge-success" :
                          appointment.appStatus?.appointmentStatus?.includes("CONFIRMED") ? "hm-badge hm-badge-info" :
                          "hm-badge hm-badge-warning"
                        }>
                          {appointment.appStatus?.appointmentStatus}
                        </span>

                        {userRole !== 'ROLE_EMPLOYER' &&
                          appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
                          appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED' && (
                          <div className="d-flex flex-wrap gap-1 mt-2">
                            {appointment.appStatus?.appointmentStatus === 'APPOINTMENT RESCHEDULED' &&
                              appointment.appStatus?.updatedBy !== 'Employee' && (
                              <button
                                className="btn btn-success btn-sm rounded-pill px-2"
                                onClick={() => handleAcceptAppointment(appointment.id)}
                              >Accept</button>
                            )}
                            <button
                              className="btn btn-outline-danger btn-sm rounded-pill px-2"
                              onClick={() => handleCancelAppointment(appointment.id)}
                            >Cancel</button>
                            <button
                              className="btn btn-outline-warning btn-sm rounded-pill px-2"
                              onClick={() => handleRescheduleAppointment(appointment.id)}
                            >Reschedule</button>
                          </div>
                        )}
                      </td>

                      <td>
                        {appointment.orderStatus?.appointmentReport ? (
                          <a href={appointment.orderStatus.appointmentReport} target="_blank" rel="noopener noreferrer" className="hm-badge hm-badge-success text-decoration-none">
                            View
                          </a>
                        ) : appointment.reportstatus === 'APPROVED' ? (
                          <ul className="list-unstyled mb-0">
                            {(appointment.reports || []).map((report, ri) => (
                              <li key={report.id} className="d-flex align-items-center gap-2 mb-1">
                                <span
                                  className="text-primary"
                                  style={{ cursor: 'pointer', fontSize: '0.78rem' }}
                                  onClick={() => handleViewReport(report.id)}
                                >
                                  {report.fileName || `File ${ri + 1}`}
                                </span>
                                <FaDownload
                                  size={12}
                                  style={{ cursor: 'pointer', color: '#198754' }}
                                  onClick={() => handleDownloadReport(report.id, report.fileName)}
                                />
                              </li>
                            ))}
                          </ul>
                        ) : appointment.reportstatus === 'REQUESTED' && (userRole === 'ROLE_ADMIN' || userRole === 'ROLE_SUPER') ? (
                          <div className="d-flex align-items-center gap-2">
                            <span className="hm-badge hm-badge-warning">Pending</span>
                            <BiSolidCheckCircle
                              style={{ color: "green", cursor: "pointer", fontSize: "1.2rem" }}
                              title="Approve"
                              onClick={(e) => rsubmit(e, appointment.id, "APPROVED")}
                            />
                            <BiSolidXCircle
                              style={{ color: "red", cursor: "pointer", fontSize: "1.2rem" }}
                              title="Reject"
                              onClick={(e) => rsubmit(e, appointment.id, "REJECTED")}
                            />
                          </div>
                        ) : (
                          <span className="text-muted small">
                            {appointment.reportstatus || "No Report"}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="d-flex justify-content-center py-3">
              <Pagination className="hm-pagination">
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage >= totalPages - 1} />
              </Pagination>
            </div>
          )}
        </div>
      </div>

      {isUploadModalOpen && (
        <UploadDoctorApppointmentReport
          isOpen={isUploadModalOpen}
          onRequestClose={handleCloseUploadModal}
          appointmentId={selectedAppointmentId}
        />
      )}

      {showImageModal && (
        <DoctorDisclaimerPopup isOpen={showImageModal} onRequestClose={handleCloseModal} userid={userid} />
      )}

      {isReschedulePopupOpen && (
        <RescheduleDoctorAppointment
          isOpen={isReschedulePopupOpen}
          onRequestClose={handleCloseReschedulePopup}
          doctorAppointmentId={selectedAppointmentId}
        />
      )}

      {isCancelPopupOpen && (
        <CancelDoctorAppointment
          isOpen={isCancelPopupOpen}
          onRequestClose={handleCloseCancelPopup}
          doctorAppointmentId={selectedAppointmentId}
        />
      )}

      {loader && <div className="loading"></div>}
    </div>
  );
}

export default EmployeeDoctorAppointment;
